import _ from 'underscore';
import { currencyStrings } from './consts';

export const serializeCurrencies = (supportedCurrencies, i18n) =>
  _.map(supportedCurrencies, (currency) => {
    const Code = _.get(currency, ['value', 'Code']);
    const Id = _.get(currency, ['value', 'Id']);

    return {
      Code,
      Id,
      currency: Code,
      currencyLocalizationKey: currencyStrings && i18n.getString(currencyStrings[Code]),
      key: Code,
      text: currencyStrings && i18n.getString(currencyStrings[Code]),
    };
  });

